/**
 * Per-page metadata via React 19 native <title>/<meta> hoisting.
 * Social crawlers that don't run JS fall back to the static defaults in index.html;
 * browsers and Google (which renders JS) pick up these per-page values.
 *
 * NOTE: set SITE_URL to the production domain (used for canonical/og/hreflang).
 */
const SITE_URL = "https://avoria.com";

type Props = {
  title: string;
  description: string;
  /** Route path beginning with "/" (e.g. "/about"). */
  path: string;
};

const Seo = ({ title, description, path }: Props) => {
  const url = SITE_URL + (path === "/" ? "" : path);

  return (
    <>
      <title>{title}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={url || `${SITE_URL}/`} />

      {/* Open Graph (per-page overrides; static defaults live in index.html) */}
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url || `${SITE_URL}/`} />

      {/* Twitter */}
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />

      {/* Bilingual alternates (?lng switches language; same content URL) */}
      <link rel="alternate" hrefLang="en" href={`${url || `${SITE_URL}/`}?lng=en`} />
      <link rel="alternate" hrefLang="pt-BR" href={`${url || `${SITE_URL}/`}?lng=pt`} />
      <link rel="alternate" hrefLang="x-default" href={url || `${SITE_URL}/`} />
    </>
  );
};

export default Seo;
